import errorHandler from '@/ft-vue-core/mixins/errorHandler'
import LocationMealPeriodLinkedInput from './LocationMealPeriodLinkedInput'
export default {
  components: {LocationMealPeriodLinkedInput},
  mixins: [errorHandler],
  data () {
    return {
      locations: []
    }
  },
  mounted () {
    this.$ftAPI().get(this.addResourceErrorHandler({
      command: 'diningLocation',
      load: this.locations,
      loading: this.isLoading
    }))
  }
}